import React, { Component } from "react";
import { Row, Col, Button, Image } from "react-bootstrap";
import InputField from "../../components/InputFieldComponent";
import { SettingHeader } from "./../TutorSetting/SpecificSettingComp";
import { updatePassword } from "./../../apis/tutors";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { InfoModal } from "./../../components/modals/InfoModal";
import warning from "../../assets/icons/warning.png";

class ChangePasswordSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      reNewPassword: "",
      errorMessage: "",
    };
  }

  onUpdatePassword = () => {
    const { oldPassword, newPassword, reNewPassword } = this.state;
    const { user } = this.props;
    let error = "";

    updatePassword({ email: user.email, newPassword, oldPassword })
    .then((res) => {
      if (res.status === 200) {
        this.setState({
          oldPassword: "",
          newPassword: "",
          reNewPassword: "",
          errorMessage: "",
        });
        InfoModal("Updates", "Successfully Update");
        // this.props.onHide();
        // this.props.onSuccess();
      } else {
        if (JSON.parse(JSON.stringify(res.response)).status === 403) {
          InfoModal(
            "Error",
            JSON.parse(JSON.stringify(res.response)).data.message
          );
        } else {
          if (JSON.parse(JSON.stringify(res.response)).data?.updatePassword) {
            error = JSON.parse(JSON.stringify(res.response)).data
              .updatePassword;
          } else {
            error = JSON.parse(JSON.stringify(res.response)).data.err;
          }
          return error === "Invalid old password"
            ? this.setState({
                errorMessage: "Your old password was incorrect. Please try again",
              })
            : "";
        }
      }
    })
    .catch((err) => console.log(err));
  
  };

  handleInputChange = (e) => {

    this.setState({
      [e.target.name]: e.target.value,
    });

  };

  submit = (error) => {
    confirmAlert({
      title: "Error",
      message: error,
      buttons: [
        {
          label: "Ok",
          onClick: () => {},
        },
      ],
    });
  };

  render() {

    const { isModalChangePassword, onHide } = this.props;
    const { oldPassword, newPassword, reNewPassword, errorMessage } = this.state;

    let warningError = ( <img src={warning} alt="warning" width="14px" height="14px" style={{ marginRight: "6px" }}/> );

    return (
      <div className="container">
        <Row className="flex-center-center">
          <Col lg={8} md={8} sm={12} xs={12} className="change-password-setting">
            <SettingHeader
              settingName={"Log in and security"}
              headerTitle={"Change password"}
              headerDesciption={"Choose a unique password to protect your account"}
              goToAccount={() => this.props.history.push("/tutor-setting")}
            />

            <p className="label">Type your current password</p>
            <input
              type="password"
              name="oldPassword"
              value={oldPassword}
              onChange={this.handleInputChange}
              className={ errorMessage ? "form-control errorInput" : "form-control"}
            />
            {
              errorMessage ?
                <div className="error">
                  { warningError }{ errorMessage }
                </div> : ""
            }

            <p className="label">Type your new password</p>
            <input
              type="password"
              name="newPassword"
              value={newPassword}
              onChange={this.handleInputChange}
              className={ newPassword !== reNewPassword || ( newPassword && newPassword.length < 8 ) ? "form-control errorInput" : "form-control"}
            />

            <p className="label">Re-type your new password</p>
            <input
              type="password"
              name="reNewPassword"
              value={reNewPassword}
              onChange={this.handleInputChange}
              className={ newPassword !== reNewPassword || ( reNewPassword && reNewPassword.length < 8 ) ? "form-control errorInput" : "form-control"}
            />
            
            <div className="error">
              { 
                newPassword !== reNewPassword ? 
                  warningError 
                    : ( newPassword && newPassword.length < 8 ) || ( reNewPassword && reNewPassword.length < 8 )
                      ? warningError
                        : "" 
              }
              { 
                newPassword !== reNewPassword ? 
                  "Your new passwords did not match. Please try again" 
                    : ( newPassword && newPassword.length < 8 ) || ( reNewPassword && reNewPassword.length < 8 )
                      ? "Your password isn't strong enough, try making it longer."
                        : "" 
              }
            </div>

            <button className="update" onClick={this.onUpdatePassword}>Update password</button>
            <hr />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    UserReducer: { user },
  } = state;
  return {
    user,
  };
};

export default connect(mapStateToProps, null)(ChangePasswordSetting);
